import { render } from "./miperfil.vue?vue&type=template&id=4cf2432e&scoped=true"
import script from "./miperfil.vue?vue&type=script&lang=js"
export * from "./miperfil.vue?vue&type=script&lang=js"

import "./miperfil.vue?vue&type=style&index=0&id=4cf2432e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf2432e"]])

export default __exports__